import React, { FC } from "react";
import { SvgIcon } from "@mui/material";

export const ChimneyIcon: FC = () => {
  return (
    <SvgIcon viewBox="0 0 24 24">
      {/* Chimney stack with rounded bottom corners */}
      <path
        d="M7 8 L7 20 Q7 22 9 22 L15 22 Q17 22 17 20 L17 8 Z"
        fill="currentColor"
      />

      {/* Chimney cap with rounded top corners */}
      <path
        d="M6 7 Q6 5 8 5 L16 5 Q18 5 18 7 L18 10 L6 10 Z"
        fill="currentColor"
      />

      {/* Chimney hat (curved arc with air gap and pronounced curve) */}
      <path
        d="M6 3.5 Q12 0.5 18 3.5"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};
